import React, { useState, useRef, useEffect } from 'react'
import { VerticalScrollBar } from '.'
import SearchBar from './SearchBar'
import { dropdownDownArrow, dropdownUpArrow, red_info } from '../../../assets/images'

const MisSingleSelect = (
  { 
    name = '', 
    data = [''], 
    dataList=[],
    values = [], 
    labelTag='', 
    labelTagClasses = '',
    placeholder = 'Select', 
    label = '', 
    value = '', 
    position = 'bottom', 
    bgColor='bg-gray-100', 
    labelClasses = 'text-gray-700',
    dropdownDownArrowHeight = '350px',
    placeholderClasses= !value && 'text-gray-300',
    selectClasses = 'p-4', 
    listClasses = '', 
    listItemClasses = 'p-6 pb-5',
    errorClasses= '', 
    classes = '', 
    error = '', 
    id = '', 
    border = '' ,
    inputBoxClass='', 
    lineHeight='', 
    disable= false, 
    onChangeHandler = () => {}, 
    showErrorIcon = false,
    search = false,
    src= [],
    OnBlurHandler = () => {}
  }) => {
  const [open, setOpen] = useState(false)
  const selectRef = useRef()
  const btnRef = useRef()
  const searchRef =useRef()
  let [searchTerm, setSearchTerm] = useState('');
  let [filteredData, setFilteredData] = useState(data); 
  const handler = (value) => {
    setOpen(false)
    setSearchTerm('')
    setFilteredData(data)
    if(!value) return
    onChangeHandler({name, value},id)
  }

  useEffect(() => {
    const handler = (event) => {
      if (!(event.target === searchRef.current)) return
      else if(!(event.target === selectRef.current || event.target === btnRef.current)) setOpen(false)
    }
    document.body.addEventListener('click', handler)
    return () => document.body.removeEventListener('click', handler)
  }, [])

  const valuesLen = values.length
  const dropdownIcon = src.length > 0 ? (open ? src[0] : src[1]) : (open ? dropdownUpArrow : dropdownDownArrow)
  
  
  const searchHandler= (searchTerm) => {
    setSearchTerm(searchTerm);
    filteredData = data.filter(item => item.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredData(filteredData);
  }
  return (
    <>
      <div className={`relative ${classes}`}>
        {label && <label className={`font-semibold ${labelTag ? 'mb-1': 'mb-1'} block ${labelClasses}`}>{label}</label>}
        {labelTag && <label className={`mb-3 block ${labelTagClasses ? labelTagClasses : labelClasses}`}>{labelTag}</label>}

        <button 
          ref={btnRef}
          type="button" 
          disabled={disable}
          onClick={() => setOpen(val => !val)}
          className={`${bgColor} ${selectClasses} relative w-full ${border ? border : 'border rounded-md'} border-gray-200  text-left cursor-pointer ${disable ? 'cursor-not-allowed' : 'cursor-pointer'} focus:outline-none ${inputBoxClass} text-gray-400`}
        >
          <input 
            ref={selectRef} 
            name={name} 
            value={value ? value : placeholder} 
            readOnly
            className={`${bgColor} ${placeholderClasses} block w-full pl-1 text-sm cursor-pointer focus:outline-none focus:${bgColor}-100 text-gray-500 ${lineHeight}`} style={value ? undefined : { color: '#aaa' }}
          
            onBlur={OnBlurHandler}
          />
          <span className="absolute inset-y-0 right-4  flex items-center pointer-events-none">
            <img src={dropdownIcon} />
          </span>
        </button>

        <ul
          className={`${listClasses} absolute z-10 w-full bg-white max-h-68 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm ${open ? '':'hidden'} ${position === 'top' ? '-top-28 mb-2' : 'mt-2 shadow-lg'}`} 
        > 
        { search && 
            <div ref={searchRef}>
              <SearchBar value={searchTerm}
                         placeholder="Enter your search term"
                         onValueChange={searchHandler}/>
            </div>
        }
          <VerticalScrollBar maxHeight={dropdownDownArrowHeight} scrollHeight={'30px'}>
            {(search ? filteredData : data).map((item, index)=> {
              const value = index < valuesLen ? values[index] : item
              let disableOption = dataList.find(e => e.name === item)?.['disable']
              return (
                <li 
                  key={`${item}_${index}`}
                  onClick={disableOption ? null : () => handler(value)}
                  className={`${listItemClasses} ${disableOption ? `text-gray-300`:`text-gray-500`} ${disableOption ? `cursor-not-allowed` : `cursor-pointer`} select-none relative ${!disableOption && `hover:bg-blue-100`}`}
                >
                  <span className="block truncate text-base font-semibold">
                    {item}
                  </span>
                </li>
              )
            })}
          </VerticalScrollBar>
        </ul>
        {error && <span className='text-red-300 font-sm text-normal flex flex-row'><img src={red_info} style={{marginRight : '5px'}}></img>{error}</span> }
      </div>
    </>
  )
}

export default MisSingleSelect